module.exports = ".card-img-custom {\r\n    width: 70%;\r\n    margin: 0 auto;\r\n}"